import { FC } from 'react';
import GeneralCard from '../../../general/GeneralCard';
import ExposureBarChart from './ExposureBarChart';
import { useWindowSize } from '../../../../hooks/useWindowSize';

export interface CountryCodeGrossExposureProps {
  data: FundExposureData;
  isFetching: boolean;
}

const CountryCodeGrossExposure: FC<CountryCodeGrossExposureProps> = ({
  data,
  isFetching,
}) => {
  const { width, height } = useWindowSize();
  return (
    <GeneralCard cardStyle={{ flexGrow: 1 }}>
      <ExposureBarChart
        windowWidth={width}
        isFetching={isFetching}
        windowHeight={height}
        inputData={data}
        exposureType="countryCode"
        exportButton
      />
    </GeneralCard>
  );
};

export default CountryCodeGrossExposure;
